import Servico from '../../../utils/PortalServico'
import Area from './Area';
/**
 * @type {AreaServico}
 */
export default class AreaServico extends Servico {

    listarAreasNegocio() {
        const self = this
        return self.get('/wsportal/publico/listarAreasNegocio')
                    .then(resultado => resultado.map(item => Area.buildFromJson(item)));
    }

}